import React from 'react';
import type { ViewProps } from 'react-native';
import { Platform, StyleSheet, View } from 'react-native';
import { theme, useBreakpointHelpers } from '@sweetgreen/garnish';

import {
  AccountMenu,
  AccountSignedOutMessage,
  PageWrapper,
} from '@order/components';

import { ProfileScreen } from '../ProfileScreen';

export const AccountScreenContent = (
  props: AccountScreenContentProps,
): React.ReactElement => {
  const { testID, isLoggedIn } = props;
  const { isMobile } = useBreakpointHelpers();

  if (!isLoggedIn && Platform.OS === 'web') {
    return <AccountSignedOutMessage />;
  }

  if (!isMobile && isLoggedIn) {
    return <ProfileScreen />;
  }

  return (
    <PageWrapper
      testID={testID}
      style={styles.container}
      safeAreaEdges={['top']}
    >
      <View style={styles.padding}>
        <AccountMenu variant="STANDALONE" />
      </View>
    </PageWrapper>
  );
};

type AccountScreenContentProps = {
  readonly isLoggedIn: boolean;
} & Pick<ViewProps, 'testID'>;

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.colors.KHAKI_3,
  },
  padding: {
    padding: theme.spacing.medium,
  },
});
